module.exports = __webpack_public_path__ + "img/mc.fd7d44a7.svg";